export default {
  1: "PEG HOOKS",
  2: "LOZIER",
  3: "RACKINGS",
  4: "POP",
  5: "DROP SHIP",
};
